import React, { FunctionComponent } from 'react';
import type { Props } from './types';
import { FlashBox } from '../../atoms/flashBox';
import { RecruitmentHeaderSp } from '../../molecules/recruitmentHeaderSp';
import { RecruitmentHeaderPc } from '../../molecules/recruitmentHeaderPc';
import { RecruitmentList } from '../../organisms/recruitmentList';
import { RecruitmentSearchForm } from '../../organisms/recruitmentSearchForm';
import { RecruitmentSort } from '../../../types/recruitments';
import { NewUserRecommendModal } from '../../molecules/newUserRecommendModal';

export const Presentation: FunctionComponent<Props> = ({
  shouldTriggerSearch,
  h1Title,
  fromFixed,
  fromSearchPage,
  subContentTop,
  noCompanyIcon,
  noimage,
  offline011Pc,
  offline011Sp,
  hoverIcon,
  isStopped,
  isCompany,
  isPage,
  searchState,
  uiState,
  metaState,
  apiState,
  sort,
  handlePaginateClick,
  handleChangeQ,
  handleSearch,
  handleOpenSp,
  handleFetchSort,
  handleClick,
  handleFetchOccupationDetails,
  handleFetchPrefectureDetails,
  checkAllOccupationDetails,
  checkAllPrefectureDetails,
  openList,
  handlePopup,
  handleModal,
  closePopup,
  handleChangeUrl,
  renderSubContent,
  handleClearAll,
  handleClearEmploymentTypes,
  handleSelectAllEmploymentTypes,
  handleClearOccupations,
  handleSelectAllOccupations,
  handleClearLocations,
  handleSelectAllLocations,
  handleClearPreferenceConditions,
  handleSelectAllPreferenceConditions,
  handleChangeSalary,
  handleClearAreas,
  handleClearPrefectureDetails,
  searchHistories,
  handleApplySearchHistory,
  handleSaveConditions,
  saveConditions,
  handleDeleteSaveConditions,
  isShowCompanyInfo,
  isShowAttentionPeople,
  flash,
  flashType,
  flashMessage,
  handleFlash,
  isModalOpen,
  recommendRecruitments,
  handleModalClose,
  onFirstLoad,
  listRef,
  showNewGradBanner,
}) => {

  if (!searchState || !uiState || !metaState || !apiState || !handleSearch || !handleOpenSp) return null;

  return (
    <div className="l-articles js-background-fixed">
      <div className={`l-articles-inner--recruitment u-clear ${fromSearchPage && !uiState.isPc ? 'pb' : ''}`}>
        <h1 className={`articles-title ${subContentTop ? 'margin' : ''}`}>
          {h1Title || ''}
          {fromFixed && metaState.page !== 1 && `（${metaState.page}ページ目）`}
        </h1>

        {/* OFFLINEバナー非表示 */}
        {/* {showNewGradBanner && offline011Pc && offline011Sp && (
          <a href="/lp/offline/tokyo" className="offline gtm-offline-view-count" data-event-name="offline on screen" data-event="click" data-category="recruitmentlist" data-value="offline011_banner">
            <picture>
              <source srcSet={offline011Pc} media="(min-width: 768px)" />
              <img src={offline011Sp} alt="OFFLINEイベントバナー" />
            </picture>
          </a>
        )} */}

        {metaState.page === 1 && subContentTop && renderSubContent && renderSubContent()}

        {!uiState.isPc && handleChangeQ && (
          <RecruitmentHeaderSp
            q={searchState.q}
            isReleasedRecruitmentsNone={false}
            targetEmploymentTypes={searchState.target_employment_types}
            targetOccupations={searchState.target_occupations}
            targetOccupationDetails={searchState.target_occupation_details}
            occupationDetailsOccupationIds={searchState.occupationDetailsOccupationIds}
            targetPrefectureDetails={searchState.target_prefecture_details}
            handleChangeQ={handleChangeQ}
            handleSearch={handleSearch}
            handleOpenSp={handleOpenSp}
            handleModal={handleModal}
          />
        )}

        <main ref={listRef} className="l-articles-main articles-container" style={{ border: 'none' }}>
          {handleFetchSort && (
            <RecruitmentHeaderPc
              sort={sort}
              isPc={uiState.isPc}
              handleFetchSort={handleFetchSort}
              page={metaState.page}
              recruitmentsCount={apiState.recruitment_ids ? apiState.recruitment_ids.length : 0}
              dataCategory={metaState.dataCategory}
              dataValue={metaState.dataValueRecruitmentHeaderPc}
            />
          )}

          {apiState.recruitment_ids && handlePaginateClick && handlePopup && (
            <RecruitmentList
              recruitment_ids={apiState.recruitment_ids}
              similar_recruitment_ids={apiState.similar_recruitment_ids}
              noCompanyIcon={noCompanyIcon || ''}
              noimage={noimage || ''}
              hoverIcon={hoverIcon || ''}
              page={metaState.page}
              handlePaginateClick={handlePaginateClick}
              loading={uiState.loading}
              isPc={uiState.isPc}
              chromeEdg={uiState.chromeEdg}
              isStopped={isStopped || false}
              isCompany={isCompany}
              dataCategory={metaState.dataCategory}
              dataValue={metaState.dataValueRecruitmentList}
              dataClickPoint={metaState.dataClickPoint}
              sort={sort as RecruitmentSort}
              isShowAttentionPeople={isShowAttentionPeople}
              onFirstLoad={onFirstLoad}
            />
          )}
        </main>

        <aside className={`search-form ${uiState.popupOpen && 'search-form__open'}`} style={uiState.toggleStyle}>
          {handleClick && handleChangeQ && handleFetchOccupationDetails &&
          handleFetchPrefectureDetails && checkAllOccupationDetails &&
          checkAllPrefectureDetails && openList && handlePopup &&
          closePopup && handleChangeUrl && handleModal && handleClearAll && (
            <RecruitmentSearchForm
              shouldTriggerSearch={shouldTriggerSearch}
              isFromRecruitmentPage={true}
              isPage={isPage}
              q={searchState.q}
              recruitment_employment_types={apiState.recruitment_employment_types}
              occupations={apiState.occupations}
              occupation_details={apiState.occupation_details}
              search_occupation_details={apiState.search_occupation_details}
              side_prefectures={apiState.side_prefectures}
              all_prefectures={apiState.all_prefectures}
              detail_prefectures={apiState.detail_prefectures}
              target_employment_types={searchState.target_employment_types}
              target_occupations={searchState.target_occupations}
              target_occupation_details={searchState.target_occupation_details}
              target_prefectures={searchState.target_prefectures}
              target_prefecture_details={searchState.target_prefecture_details}
              target_preference_conditions={searchState.target_preference_conditions}
              target_working_periods={searchState.target_working_periods}
              preference_condition_categories={apiState.preference_condition_categories}
              target_salary_type={searchState.target_salary_type}
              target_salary_min={searchState.target_salary_min}
              target_salary_max={searchState.target_salary_max}
              handleChangeSalary={handleChangeSalary}
              handleClick={handleClick}
              handleSearch={handleSearch}
              handleChangeQ={handleChangeQ}
              handleFetchOccupationDetails={handleFetchOccupationDetails}
              handleFetchPrefectureDetails={handleFetchPrefectureDetails}
              checkAllOccupationDetails={checkAllOccupationDetails}
              checkAllPrefectureDetails={checkAllPrefectureDetails}
              occupationDetailsOccupationIds={searchState.occupationDetailsOccupationIds}
              recruitmentsCount={apiState.recruitment_ids.length}
              prefectureDetails={searchState.prefectureDetails as any}
              spStyle={uiState.spStyle}
              isSp={uiState.isSp}
              toggleListStyle={uiState.toggleListStyle}
              openList={openList}
              handlePopup={handlePopup}
              handleModal={handleModal}
              popupStyle={uiState.popupStyle}
              modalStyle={uiState.modalStyle}
              handleOpenSp={handleOpenSp}
              closePopup={closePopup}
              isPc={uiState.isPc}
              page={metaState.page}
              handleChangeUrl={handleChangeUrl}
              handleClearAll={handleClearAll}
              handleClearEmploymentTypes={handleClearEmploymentTypes}
              handleSelectAllEmploymentTypes={handleSelectAllEmploymentTypes}
              handleClearOccupations={handleClearOccupations}
              handleSelectAllOccupations={handleSelectAllOccupations}
              handleClearLocations={handleClearLocations}
              handleSelectAllLocations={handleSelectAllLocations}
              handleClearPreferenceConditions={handleClearPreferenceConditions}
              handleSelectAllPreferenceConditions={handleSelectAllPreferenceConditions}
              handleClearAreas={handleClearAreas}
              handleClearPrefectureDetails={handleClearPrefectureDetails}
              searchHistories={searchHistories}
              handleApplySearchHistory={handleApplySearchHistory}
              handleSaveConditions={handleSaveConditions}
              saveConditions={saveConditions}
              handleDeleteSaveConditions={handleDeleteSaveConditions}
            />
          )}
        </aside>

        <div
          className="search-form__popup--bg"
          style={uiState.spStyle}
          onClick={handleOpenSp}
        />

        <FlashBox
          flash={flash}
          flashType={flashType}
          flashMessage={flashMessage}
          handleFlash={handleFlash}
        />

        <NewUserRecommendModal
          isShowCompanyInfo={isShowCompanyInfo ?? false}
          isModalOpen={isModalOpen}
          recommendRecruitments={recommendRecruitments}
          handleModalClose={handleModalClose}
        />
      </div>
    </div>
  );
};
